import { useState } from 'react'

export function usePagination(initialPage = 1) {
  const [currentPage, setCurrentPage] = useState(initialPage)

  const goToPage = (page, totalPages) => {
    if (isNaN(page)) return
    if (page < 1) page = 1
    if (page > totalPages) page = totalPages

    setCurrentPage(page) 
  }

  const handlePaginationClick = (event, totalPages) => {
    let target = event.target
    if (target.tagName === 'svg' || target.tagName === 'path') {
      target = target.closest('a')
    }

    if (!target) return
    const targetId = target.id || ''

    switch (targetId) {
      case 'first-page':
        goToPage(1, totalPages)
        break
      case 'last-page':
        goToPage(totalPages, totalPages)
        break
      case 'previous-page':
        goToPage(currentPage - 1, totalPages)
        break
      case 'next-page':
        goToPage(currentPage + 1, totalPages)
        break
      default:
        if (!isNaN(targetId)) {
          goToPage(parseInt(targetId, 10), totalPages)
        }
        break
    }
  }

  return { currentPage, setCurrentPage, handlePaginationClick }
}
